var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.params.label}},[_c('w-areaid',{staticStyle:{"display":"inline-block"},attrs:{"detail":{areaId: _vm.regionId},"placeholder":"请填写"},on:{"input":_vm.changeArea}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }